module.exports = __webpack_public_path__ + "img/background.ac1c54eb.jpg";